import { validationMessages } from '../../../app/utils/validationMessages';

const cpdFormModel = {
  formId: 'CpdForm',
  formField: {
    Year: {
      name: 'Year',
      label: 'Year'
    },
    CategoryFilter: {
      name: 'Category',
      label: 'Category'
    },
    Category: {
      name: 'Category',
      label: 'Category*',
      informationText: 'Please select a category. If you are unsure of the category your activity relates to, please consult the guidelines (link on the portal)',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    Status: {
      name: 'Status',
      label: 'Status'
    },
    ActivityDate: {
      name: 'ActivityDate',
      label: 'Date of activity*',
      informationText: 'Enter the date the activity took place',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get minDateErrorMsg(): string {
        return `${this.label.replace('*', '')} must start from 1st May 2025.`;
      },
      get typeError(): string {
        return validationMessages.invalid(this.label);
      }
    },
    ActivityType: {
      name: 'ActivityType',
      label: 'Activity type*',
      informationText: 'Please select an activity',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    Domains: {
      name: 'Domains',
      label: 'Domains of good practice*',
      informationText: 'Please select one or multiple domains',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    CreditsClaiming: {
      name: 'CreditsClaiming',
      label: 'Credits*',
      informationText: 'Please select the credits awarded for attending this activity',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      maxValue: 40,
      minValue: 0.5,
      get minimumValueErrorMessage(): string {
        return `Minimum value ${this.minValue}`;
      },
      get maximumValueErrorMessage(): string {
        return `Maximum value ${this.maxValue}`;
      }
    },
    Description: {
      name: 'Description',
      label: 'Activity description*',
      maxStringCount: 4000,
      informationText: 'Please give a brief description of the activity attended',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    DevelopmentPurpose: {
      name: 'DevelopmentPurpose',
      label: 'Development purpose',
      maxStringCount: 500,
      informationText: 'Please give an outline of the development purpose of this activity',
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    SupportingDocument: {
      name: 'SupportingDocument',
      label: 'Attach supporting document',
      informationText: 'Please upload proof of attendance / cerificate',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      invalidFileTypeErrorMsg: validationMessages.invalidFileType('PDF, Text, Word, Excel, JPEG, GIF, PNG or Powerpoint'),
      invalidFileSizeErrorMsg: validationMessages.invalidFileSize(5),
      fileNotUploaded: `Supporting document not uploaded.`
    }
  }
};

export default cpdFormModel;
